import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };

const transactionRequestService = {
  // MODIFIED: Renamed to match your specific requirement
  getEmployeeUnderMe: async (approverId, days, requestTypeId = 0) => {
    const res = await axios.get(`${domain}/api/MaintenanceTransactionRequest/get-employee-under-me/${approverId}`, {
      params: { days, requestTypeId },
      headers
    });
    return res.data;
  },

  actionRequest: async (payload) => {
    return await axios.post(`${domain}/api/MaintenanceTransactionRequest/action`, payload, { headers });
  }
};

export default transactionRequestService;